import React from "react";
import ct from "class-types.macro";

interface Props {
  pageHeader: string;
  showNoSearchResultsMessage: boolean;
  searchTerm: string;
}
const OutletHeader = ({
  pageHeader,
  showNoSearchResultsMessage,
  searchTerm,
}: Props) => {
  return (
    <>
      {showNoSearchResultsMessage ? (
        <>
          <p className={ct("font-semibold", "text-3xl", "mb-1", "mt-8")}>
            Sorry, we couldn&apos;t find any matches for &quot;
            {searchTerm}
            &quot;
          </p>
          <p className={ct("text-lg")}>
            Try searching for another product, or browse all Outlet Items below.
          </p>
        </>
      ) : (
        <h1 className="page-header">{pageHeader}</h1>
      )}
    </>
  );
};
export default OutletHeader;
